import Spinner from "../../core/spinner"

const LoadingView = ({text}) => (
    <div className='security-card'>
        <div className='mfa-loading'>
            <Spinner />
            <span>{text.setting_up}</span>
        </div>
    </div>
)

export default LoadingView
